'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useState, useEffect, useContext } from 'react';
import noop from '../utils/noop';
import { jsx as _jsx } from "react/jsx-runtime";
export var FeatureToggleContext = createContext({
  featureToggles: {},
  setFeatureToggles: noop
});
export function useFeatureToggleData() {
  return useContext(FeatureToggleContext);
}
var UNSAFE_OVERRIDE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);
export function getBrowserFtOverrides() {
  var overrides = {};
  var row = document.cookie.split(/;\s*/).find(entry => entry.startsWith('ftOverride='));
  if (!row) {
    return overrides;
  }
  var ftOverrideCookie;
  try {
    ftOverrideCookie = decodeURIComponent(row.slice(row.indexOf('=') + 1));
  } catch (_unused) {
    return overrides;
  }
  ftOverrideCookie.split(',').forEach(pair => {
    var _pair$split = pair.split('='),
      _pair$split2 = _slicedToArray(_pair$split, 2),
      rawKey = _pair$split2[0],
      rawValue = _pair$split2[1];
    var key = rawKey === null || rawKey === void 0 ? void 0 : rawKey.trim();
    var value = rawValue === null || rawValue === void 0 ? void 0 : rawValue.trim();
    if (key && value && !UNSAFE_OVERRIDE_KEYS.has(key)) {
      overrides[key] = value === 'true';
    }
  });
  return overrides;
}
export var FeatureToggleContextProvider = _ref => {
  var children = _ref.children,
    defaultFeatureToggles = _ref.defaultFeatureToggles;
  var _useState = useState(defaultFeatureToggles !== null && defaultFeatureToggles !== void 0 ? defaultFeatureToggles : {}),
    _useState2 = _slicedToArray(_useState, 2),
    featureToggles = _useState2[0],
    setFeatureToggles = _useState2[1];
  useEffect(() => {
    var ftOverrides = getBrowserFtOverrides();
    if (Object.keys(ftOverrides).length === 0) {
      return;
    }
    setFeatureToggles(current => {
      var scopedOverrides = Object.keys(ftOverrides).reduce((acc, key) => {
        if (Object.prototype.hasOwnProperty.call(current, key)) {
          acc[key] = ftOverrides[key];
        }
        return acc;
      }, {});
      return Object.keys(scopedOverrides).length > 0 ? _objectSpread(_objectSpread({}, current), scopedOverrides) : current;
    });
  }, []);
  useEffect(() => {
    sessionStorage.setItem('featureToggles', JSON.stringify(featureToggles));
  }, [featureToggles]);
  return _jsx(FeatureToggleContext.Provider, {
    value: {
      featureToggles,
      setFeatureToggles
    },
    children: children
  });
};